/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// show and hide div based on description variant <div data-description-variant="Cleansing Balm"></div>
if (document.body.classList.contains('template-product')) {

  // show the first description variant
  // get all description variants
  const descriptionVariants = document.querySelectorAll('[data-description-variant]');
  if (descriptionVariants.length > 0) {
    descriptionVariants.forEach(function(element) {
      element.style.display = 'none';
    });
    descriptionVariants[0].style.display = 'block';
  }


  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    // console.log('DEBUG: variant changed',variant);
  
    const descriptionVariants = document.querySelectorAll('[data-description-variant]');
    if (descriptionVariants.length > 0) {
      descriptionVariants.forEach(function(element) {
      element.style.display = 'none';
  
      if (element.getAttribute('data-description-variant') == variant.title) {
        element.style.display = 'block';
      }
      
      });
    }
  });

  

}

